// extracted by mini-css-extract-plugin
export default {"senderPhone":"src-pages-Order-Components-EditSenderInfo-css-module__senderPhone--nOCkn"};